
<template>
    <div class="container">
        <div class="list">
            <template v-for="(item, idx) in list">
                <div
                    @click="chooseHandler(item.type)"
                    class="item"
                    v-if="
                        auths.find((o) => {
                            return item.type === o.medicalCardType;
                        })
                    "
                    :key="idx"
                >
                    <div class="content">
                        <span class="title">{{ item.title }}</span>
                        <span class="details">{{ item.details }}</span>
                    </div>
                    <div class="icon">
                        <img :src="item.icon" alt />
                    </div>
                </div>
            </template>
        </div>
    </div>
</template>


<script>
import medicalCardApi from '@/api/medicalCardApi';

export default {
    data() {
        return {
            list: [
                {
                    type: 1,
                    title: '绑定就诊卡',
                    details: '已成功在医院窗口办理的就诊卡在此绑定',
                    icon: require('@/assets/icon/card_choose_1.png')
                }, {
                    type: 2,
                    title: '电子健康卡注册',
                    details: '患者通过本人身份证实名认证完成办卡，可预约挂号、在线咨询。',
                    icon: require('@/assets/icon/card_choose_2.png')
                }
            ],
            auths: []
        };
    },
    created() {
        medicalCardApi.queryMedicalCardSettings(this.organId).then(res => {
            this.auths = res.data;
        });
    },
    methods: {
        chooseHandler(type) {
            const { $router, organId } = this;
            if (2 === type) {
                $router.push({
                    path: '/medical_card/register_health_card',
                    query: {
                        organId
                    }
                });
            }
        }
    },
    props: {
        organId: {
            type: String,
            required: true
        }
    }
}
</script>


<style lang="less" scoped>
.container {
    padding: 0.4rem 0.266667rem;

    .list {
        .item:not(:first-child) {
            margin-top: 0.4rem;
        }

        .item {
            height: 2.666667rem;
            border-radius: 0.133333rem;
            position: relative;
            padding: 0.1rem 0.2rem;
            box-shadow: 0px 0px 0.13rem rgba(0, 0, 0, 0.2);
            display: flex;
            justify-content: space-around;
            background-color: @white-color;
            align-items: center;

            .content {
                flex: 1;
                padding-left: 0.2rem;

                .title {
                    font-size: 0.426667rem;
                    font-weight: 600;
                    display: block;
                    color: @black-color;
                }

                .details {
                    margin-top: 0.4rem;
                    font-size: 0.32rem;
                    display: block;
                    color: @grey-color;
                }
            }

            .icon {
                margin: 0 0.4rem;

                > img {
                    width: 1.333333rem;
                    height: 1.333333rem;
                }
            }
        }
        .item:active {
            transform: translate(0.02rem, 0.02rem);
        }
    }
}
</style>